import { createSlice } from '@reduxjs/toolkit';

export type SearchInitialState = {
  searchTerm: string;
};

const initialState: SearchInitialState = {
  searchTerm: ''
};

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.searchTerm = payload;
    }
  }
});

export const searchActions = searchSlice.actions;
